import { Injectable } from '@angular/core';
import { HttpInterceptor } from './httpInterceptor.service';
import { environment } from '../../../environments/environment';
@Injectable({
    providedIn: 'root'
})
export class AppInitializeService {
    constructor(private httpInterceptor: HttpInterceptor) { }
    private setupEnvironmentEndpoints() {
        switch (environment['name']) {
            case 'uat':
                break;
            default:
                break;
        }
    }
}
